import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import localStorageKey from "../enumerations/localStorageKey";
import bn from "../locales/bn.json";
import cn from "../locales/cn.json";
import en from "../locales/en.json";
import es from "../locales/es.json";
import id from "../locales/id.json";
import ind from "../locales/in.json";
import jp from "../locales/jp.json";
import kr from "../locales/kr.json";
import my from "../locales/my.json";
import pk from "../locales/pk.json";
import pt from "../locales/pt.json";
import th from "../locales/th.json";
import vn from "../locales/vn.json";
// the translations
// (tip move them in a JSON file and import them)
const resources = {
  en: { translation: en },
  zh: { translation: cn },
  vi: { translation: vn },
  pt: { translation: pt },
  th: { translation: th },
  id: { translation: id },
  ms: { translation: my },
  jp: { translation: jp },
  ko: { translation: kr },
  es: { translation: es },
  in: { translation: ind },
  bn: { translation: bn },
  ur: { translation: pk },
};
const nowLangProcess = () => {
  const localLang =
    window?.localStorage?.getItem(localStorageKey.DEFAULT_LANG) ??
    process.env.REACT_APP_DEFAULT_LANG;
  if (localLang) {
    return localLang;
  } else {
    return process.env.REACT_APP_DEFAULT_LANG;
  }
};
const nowLang = nowLangProcess();
i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: nowLang,
    fallbackLng: nowLang,
    keySeparator: false,
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
